import { MouseEventHandler } from 'react';
import cn from 'classnames';
import styles from './Chip.module.scss';

export interface ChipProps {
    text: string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    className?: string;
}

export function Chip({ text, onClick, className }: ChipProps): React.JSX.Element {
    return (
        <button onClick={onClick} className={cn(styles.chip, className)} type="button">
            <span>{text}</span>
        </button>
    );
}
